import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import { AirportService } from '../../airport/airport.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
var AirportResolver = /** @class */ (function () {
    function AirportResolver(document, _router, _airportService, _errorHandler, _businessManagerService, _toggleService) {
        this.document = document;
        this._router = _router;
        this._airportService = _airportService;
        this._errorHandler = _errorHandler;
        this._businessManagerService = _businessManagerService;
        this._toggleService = _toggleService;
    }
    AirportResolver.prototype.resolve = function (route, state) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, airport, isFlightDeckAdmin, isAirportManager, isBusinessOwner, _i, _a, business, e_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 10, , 11]);
                        id = route.paramMap.get('id');
                        return [4 /*yield*/, this._airportService.getAirport(id)];
                    case 1:
                        airport = _b.sent();
                        return [4 /*yield*/, this._businessManagerService.isFlightDeckAdmin()];
                    case 2:
                        isFlightDeckAdmin = _b.sent();
                        return [4 /*yield*/, this._businessManagerService.userManagesAirport(airport.airportId)];
                    case 3:
                        isAirportManager = _b.sent();
                        this._toggleService.setState(false);
                        isBusinessOwner = false;
                        if (!(airport && !isFlightDeckAdmin)) return [3 /*break*/, 7];
                        _i = 0, _a = airport.businesses;
                        _b.label = 4;
                    case 4:
                        if (!(_i < _a.length)) return [3 /*break*/, 7];
                        business = _a[_i];
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(+business.id)];
                    case 5:
                        if (_b.sent()) {
                            isBusinessOwner = true;
                        }
                        _b.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 4];
                    case 7:
                        if (!(isFlightDeckAdmin || isAirportManager || isBusinessOwner)) return [3 /*break*/, 9];
                        return [4 /*yield*/, this._airportService.getAirport(id, true)];
                    case 8:
                        airport = _b.sent();
                        _b.label = 9;
                    case 9:
                        if (airport) {
                            return [2 /*return*/, airport];
                        }
                        // this.document.location.href = environment.notFoundUrl;
                        this._router.navigate(['/404']);
                        return [2 /*return*/, null];
                    case 10:
                        e_1 = _b.sent();
                        this._errorHandler.handleError(e_1);
                        this._router.navigate(['/500']);
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    return AirportResolver;
}());
export { AirportResolver };
